<template>
  <el-select :value="value" @input="$emit('input', $event)" placeholder="请选择展示形式" :multiple="multiple">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.code">
    </el-option>
  </el-select>
</template>

<script>
import { findByType } from '@/api/template/parameter'
export default {
  name: 'ViewTypeSelect',
  props: {
    value: {},
    multiple: {
      default: true
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    fetchList () {
      findByType({
        typeVariable: 'viewType',
        scope: 'MODULE'
      })
        .then(data => {
          this.list = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    this.fetchList()
  }
}
</script>

<style scoped>

</style>
